document.addEventListener('DOMContentLoaded', function() {
    var container = document.getElementById('blog-container');
    var articlesData = container.getAttribute('data-articles');
    var blogHandle = container.getAttribute('data-blog-handle');
    if (articlesData) {
        try {
            var articles = JSON.parse(articlesData);
            if (Array.isArray(articles)) {
                function shuffle(array) {
                    for (let i = array.length - 1; i > 0; i--) {
                        const j = Math.floor(Math.random() * (i + 1));
                        [array[i], array[j]] = [array[j], array[i]];
                    }
                }
                shuffle(articles);
                var articlesToShow = articles.slice(0, 5);
                var html = '<ul>';
                articlesToShow.forEach(function(article) {
                    var url = '/blogs' + '/' + article.handle;
                    var title = article.title || 'No Title';
                    var image = article.image || 'No Image';
                    var excerpt = article.excerpt || 'No Excerpt'; // Fallback if excerpt is undefined
                    html += '<li><a href="' + url + '"><img style="width:100%;" src="'+ image +'" /><a href="' + url + '">' + title + '</a></li>';
                });
                html += '</ul>';
                container.innerHTML = html;
            } else {
                console.error('Expected articles data to be an array');
            }
        } catch (e) {
            console.error('Error parsing JSON data:');
        }
    } else {
        console.error('No articles data found');
    }
});

